import React from 'react';
import email from '../../components/email.json';
import { detectBrowser } from '../../js/common';
import { Route } from 'react-router';
import OptoutAboveBox from '../../templates/optoutabovebox/OptoutAboveBox';
import OptoutAboveBoxFr from '../../templates/optoutaboveboxfr/OptoutAboveBoxFr';
import OptoutInsideBox from '../../templates/optoutinsidebox/OptoutInsideBox';
import OptoutInsideBoxFr from '../../templates/optoutinsideboxfr/OptoutInsideBoxFr';
import ProgressMessage from '../../templates/progressmessage/ProgressMessage';
import classNames from 'classnames';

export default class OptoutTemplate extends React.Component {
  handleSendData = () => {
    this.props.sendData();
  };

  render() {
    const badBrowser = detectBrowser();
    return (
      <main>
        <div id='optinMiddle' className={classNames('content', 'centerWrap')}>
          <div className={classNames('content', 'centerWrap')}>
            <p>
              {email.optin.body.display.french.message.eng}
            </p>
            <Route component={OptoutAboveBox} />
            <div className=' borderBox'>
              <Route component={OptoutInsideBox} />
              <div className="buttonContent">
                <form id="optOutForm" method="POST" aria-label="Button" modelattribute="info" onClick={this.handleSendData}>
                  <button type="button" name="optoutButton" id="optoutButton" className="optinButton">
                    {email.optout.landing.ui.body.button.text.eng}
                  </button>
                </form>
              </div>
            </div>
            <br /> <br /> <br />
            <Route component={OptoutAboveBoxFr} />
            <div className=' borderBox'>
              <Route component={OptoutInsideBoxFr} />
              <div className="buttonContent">
                <form id="optOutForm" method="POST" aria-label="Button" modelattribute="info" onClick={this.handleSendData}>
                  <button type="button" name="optoutButton" id="optoutButton" className="optinButton">
                    {email.optout.landing.ui.body.button.text.fr}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Route component={ProgressMessage} />
      </main>
    );
  }
}
